//import templates - common event, player swap, yellow/red card, goal, (article/video?)

import {commonEventWrap} from "./templates/event-wrap.js";
import {eventDetailsWrap} from "./templates/event-details-wrap.js";
import {eventPlayer} from "./templates/player-data.js";
import {playersSwap} from "./templates/players-swap-wrap.js";
import {itemLink} from "./templates/item-wrap.js";

import {matchEventTitles} from './data/event-titles.js';


export function updateHubUI(eventsDataObj){
    console.log('Updated data:', eventsDataObj);
    let eventId = '';
    let time = '';
    let titleText = '';
    let descriptionText = '';
    let actionIconUrl = '';
    let eventDetails = '';
    let eventDetailsOptionalClass = '';
    let eventDetailsContent = '';
    let optionalClasses = '';
    let eventHtml;
    
    Object.keys(eventsDataObj).forEach(key => {
        console.log('eventsDataObj event data', eventsDataObj[key]['eventData']);
        console.log('eventsDataObj ID', eventsDataObj[key]['eventData']['event_id']);
        eventDetails = '';
        eventDetailsContent = '';
        eventId = eventsDataObj[key]['eventData']['event_id'];
        console.log('eventId', eventId, 'eventDetails', eventDetails);

        if (eventsDataObj[key]['eventData']['added_time'] > 0 && eventsDataObj[key]['eventData']['minute'] != null ) {            
            time = eventsDataObj[key]['eventData']['minute'] + '\' + ' + eventsDataObj[key]['eventData']['added_time'] + '\'' || '';            
        } else if ( eventsDataObj[key]['eventData']['minute'] != null ){
            time = eventsDataObj[key]['eventData']['minute'] + '\' ' || '';
        };
        
        titleText = matchEventTitles[eventsDataObj[key]['eventData']['action'] ] || '';        
        descriptionText = eventsDataObj[key]['eventData']['text'] ||  '';
        
        //Action icons in upper right corner
        if (eventsDataObj[key]['eventData']['action']){
            actionIconUrl = ( 'https://m3.netinfo.bg/gong/images/livescore-icons/action_' + eventsDataObj[key]['eventData']['action'] + '.svg' ) || '';
        };
        
        //If there is a player - yellow/red card, goal, swap players
        if (eventsDataObj[key]['playerData']) {
            let playerName = eventsDataObj[key]['playerData']['player_name'].split(' ')[0].trim();
            let playerSurname = eventsDataObj[key]['playerData']['player_name'].split(' ').slice(1).join(' ').trim();
            let playerShirtNumber = '';
            if (eventsDataObj[key]['playerData']['shirtnumber'] > 0 ) {
                playerShirtNumber = eventsDataObj[key]['playerData']['shirtnumber_in'];
            };
            let transferIn = '';
            let playerOptionalClass = '';
            let playerImgUrl='https://m.netinfo.bg/gong/images/player_of_the_match/player_default.png';
            if (transferIn != '') {
                playerOptionalClass = 'in';
            };
            eventDetailsContent = eventPlayer( playerName, 
                            playerSurname, 
                            playerShirtNumber,
                            playerOptionalClass,
                            playerImgUrl );
        };
        
        
        //Player Swapped
        if(eventsDataObj[key]['eventData']['action'] == '16' || eventsDataObj[key]['eventData']['action'] == '17'){
            eventDetailsOptionalClass = 'players-swap';
            let playerNameIn = eventsDataObj[key]['playerData']['player_name_in'].split(' ')[0].trim();
            let playerSurnameIn = eventsDataObj[key]['playerData']['player_name_in'].split(' ').slice(1).join(' ').trim();
            let playerShirtNumberIn = '';
            if (eventsDataObj[key]['playerData']['shirtnumber_in'] > 0 ) {
                playerShirtNumberIn = eventsDataObj[key]['playerData']['shirtnumber_in'];
            };
            let playerIn = eventPlayer( playerNameIn, 
                            playerSurnameIn, 
                            playerShirtNumberIn,
                            ' in',
                            'https://m.netinfo.bg/gong/images/player_of_the_match/player_default.png' );
                            
            let playerNameOut = eventsDataObj[key]['playerData']['player_name'].split(' ')[0].trim();
            let playerSurnameOut = eventsDataObj[key]['playerData']['player_name'].split(' ').slice(1).join(' ').trim();
            let playerShirtNumberOut = '';
            if (eventsDataObj[key]['playerData']['shirtnumber'] > 0 ) {
                playerShirtNumberOut = eventsDataObj[key]['playerData']['shirtnumber'];
            };
            let playerOut = eventPlayer( playerNameOut, 
                            playerSurnameOut, 
                            playerShirtNumberOut,
                            ' out',
                            'https://m.netinfo.bg/gong/images/player_of_the_match/player_default.png' );
                            
            eventDetailsContent = playersSwap(playerIn, playerOut);
        }
        
        
        
        
        if (eventDetailsContent != '') {
            eventDetails = eventDetailsWrap(eventDetailsContent, eventDetailsOptionalClass);
        } else {
            eventDetails = '';
        };
        
        //Гол, Гол от дузпа, Автогол
        if (eventsDataObj[key]['eventData']['action'] == '11' || eventsDataObj[key]['eventData']['action'] == '12'|| eventsDataObj[key]['eventData']['action'] == '13'){
            optionalClasses = 'goal simple';
        } else if (eventsDataObj[key]['eventData']['action'] == '18') {
        //Жълт картон и втори жълт картон
            optionalClasses = 'yellow-card';            
        } else if (eventsDataObj[key]['eventData']['action'] == '19' || eventsDataObj[key]['eventData']['action'] == '20') {
            optionalClasses = 'red-card';            
        } else {
            optionalClasses = '';     
        }
        
        console.log('eventId', eventId, 'eventDetails', eventDetails);        
        
        //If event is Article/Gallery included
        if(eventsDataObj[key]['eventData']['action'] == '31'){
            let itemUrl = eventsDataObj[key]['eventData']['content_url'];
            let itemTitle = eventsDataObj[key]['eventData']['title'];
            let itemThumbSrc = eventsDataObj[key]['eventData']['image_url'];
            let itemType = eventsDataObj[key]['eventData']['content_type'];
            eventHtml = itemLink(itemUrl, itemTitle, itemThumbSrc, itemType ='');
            
        } else {
            eventHtml = commonEventWrap(eventId, 
                                    time, 
                                    titleText, 
                                    descriptionText, 
                                    actionIconUrl, 
                                    eventDetails, 
                                    optionalClasses);
        }
        
                                    
        if( $('[events-match-id="' + eventsDataObj[key]['match_id'] + '"] .event-item#' + eventsDataObj[key]['eventData']['event_id'] ).length < 1 ){
            $('[events-match-id="' + eventsDataObj[key]['match_id'] + '"] .events-wrapper').prepend(eventHtml);
        }

    });    
}